<template>
  <p></p>
  </template>
  
  <script>
  import Events from '@/api/Events.js';
  
  export default {
    name: 'HashRedirect',
    async created() {
     /* const hash = this.$route.params.hash;
      await Events.getByHash(hash).then((resp)  =>  {
        if(resp.data != null){
          console.log("RESPONSE", resp.data)
          if(resp.data.closed == true){
            localStorage['was_closed'] = true;
          }
        }
      });
      this.$router.push('/home')*/
      
      const hash = this.$route.params.hash;
      try {
        const response = await Events.getByHash(hash);
        const eventId = response.data.id;
  
        if (!localStorage.getItem('auth')) {
          this.$store.commit('setRedirectPath', `/event-view/${eventId}`);
          this.$router.push({ name: 'Login' });
        } else {
          this.$router.push({ name: 'EventView', params: { id: eventId } });
        }
      } catch (error) {
        console.error('Erro ao buscar evento:', error);
        this.$router.push({ name: 'Home' });
      }
    }
  };
  </script>